/* global G */
import { back } from 'app/_shared/events'
import { curry } from 'lib/util'

/**
 * Clears the `equipment` attachment group and peforms a {@link back}.
 *
 * Grabs the chat url for the current equipment from the action state
 * and opens it in a new tab.
 *
 * @param {Gaia.AppModule.Spec} module          app module
 * @param {Gaia.AppModule.Action} component     action component
 * @param {Gaia.AppModule.EventHandler} event   the event that triggered this handler
 * @returns {Promise<void>}
 */
const clearGroupAndBack = async (module, component, event) => {
  const { [G.EVENTS]: eventBus } = module[G.ADAPTER]

  const data = await new Promise((resolve) => {
    eventBus.add(eventBus.type(G.ATTACHMENT, G.DONE, 'equipment'), (attachmentEvent) => {
      resolve(attachmentEvent?.detail?.[G.DATA] || [])
    }, { once: true })
    eventBus.dispatch(eventBus.type(G.ATTACHMENT, G.CACHE, 'equipment'), { [G.DATA]: {} })
  })

  if (data) {
    eventBus.dispatch(eventBus.type(G.ATTACHMENT, G.CACHE, 'equipment'), {
      [G.DATA]: {
        [G.DATA]: data.filter(attachment => attachment._rev),
      },
    })
  }

  back(module, component, event)
}

export default curry(clearGroupAndBack)
